<div class="review-list-container">
  @if (filteredReviews.length > 0) {
    @for (review of filteredReviews; track review.id) {
      <mat-card class="review-card">
        <mat-card-header class="review-header">
          @if (review.profilePictureUrl) {
            <img
              mat-card-avatar
              [src]="environment.backend + review.profilePictureUrl"
              alt="Profilbild"
              (click)="navigateToUser(review.username)"
              class="navlink"
            />
          } @else {
            <mat-icon mat-card-avatar class="navlink" (click)="navigateToUser(review.username)">person</mat-icon>
          }

          <div class="review-header-text">
            <div class="username navlink" (click)="navigateToUser(review.username)">{{ review.username }}</div>
            <div class="date">{{ review.createdAt | date: 'dd.MM.yyyy' }}</div>
            <div class="rating-stars">
              @for (star of getStarArray(review.rating); track $index) {
                <mat-icon>{{ star }}</mat-icon>
              }
            </div>
          </div>
        </mat-card-header>
        <mat-card-content>
          <p>{{ review.comment }}</p>
        </mat-card-content>
      </mat-card>
    }
  } @else {
    @if (reviews.length > filteredReviews.length) {
      <p class="no-reviews-message">Für diese Raststätte gibt es noch keine Bewertungen von anderen.</p>
    } @else {
      <p class="no-reviews-message">{{ buildNoReviewsMessage() }}</p>
    }
  }
</div>
